import { Injectable } from "@angular/core";
import { Selector, State } from "@ngxs/store";
import { INgxsFormState } from "../../model/custom/INgxsFormState";

export class OauthValidateDomainFormStateModel {
	public form: INgxsFormState;
}

@State<OauthValidateDomainFormStateModel>({
	name: "oauthValidateDomainForm",
	defaults: {
		form: {
			model: null,
			dirty: false,
			status: "",
			errors: null,
		},
	},
})
@Injectable()
export class OauthValidateDomainFormState {
	@Selector()
	static form(state: OauthValidateDomainFormStateModel) {
		return state.form;
	}
}
